const getSearchableProductText = (product) => [
  product.name,
  product.product_name,
  product.product_name_hindi,
  product.product_name_marathi,
  product.name_hindi,
  product.name_marathi,
  product.category,
  product.category_name,
  product.subcategory,
  product.subcategory_name,
  product.brand_name,
]
  .filter(Boolean)
  .join(' ')
  .toLowerCase();

export const matchesProductSearch = (product, query) => {
  const terms = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  const searchableText = getSearchableProductText(product);
  return terms.length > 0 && terms.every((term) => searchableText.includes(term));
};